import { useEffect, useState } from 'react';
import axios from '../../../api/axiosInstance';
import Loader from './Loader';
import ErrorBox from './ErrorBox';
import dayjs from 'dayjs';

export default function ActivityLog({ businessId }) {
  const [log, setLog] = useState([]);
  const [state, setState] = useState('loading');

  useEffect(() => {
    setState('loading');
    axios
      .get('/dashboard/activity', { params: { business_id: businessId } })
      .then(({ data }) => {
        setLog(data);
        setState('ready');
      })
      .catch(() => setState('error'));
  }, [businessId]);

  if (state === 'loading') return <Loader />;
  //if (state === 'error') return <ErrorBox message="Failed to load activity." />;
  if (state === 'error') return null;

  return (
    <section className="space-y-3 rounded-lg bg-white p-6 shadow">
      <h2 className="text-lg font-semibold">Employee Activity Log</h2>

      <ul className="divide-y divide-gray-200 text-sm">
        {log.map((item) => (
          <li key={item.id} className="py-2">
            <span className="mr-2 font-medium">{item.employee_name}</span>
            {item.action}
            <span className="ml-2 text-gray-500">
              {dayjs(item.created_at).fromNow()}
            </span>
          </li>
        ))}
      </ul>

      <div className="flex justify-end">
        <a
          href={`/dashboard/activity-export?business_id=${businessId}`}
          className="rounded-md border border-gray-300 bg-white px-3 py-1 text-sm hover:bg-gray-100"
        >
          Export (.csv / .pdf)
        </a>
      </div>
    </section>
  );
}
